import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useAddRoleMutation, useUpdateRoleMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { useNavigate } from "react-router-dom";

const AddRoles = ({
    mode = "add",
    isReadOnly = false,
    roleList = [],
    onClose,
    onSave,
    data = null,
}) => {

    const [addRoleApi, { isLoading }] = useAddRoleMutation()
    const [updateRoleApi, { isLoading: updateIsLoading }] = useUpdateRoleMutation()


    const validationSchema = Yup.object().shape({
        roleName: Yup.string()
            .required('Role name is required')
            .matches(/^[A-Za-z ]+$/,
                "Enter valid Role name")
            .trim(),
        description: Yup.string()
            .required('Description is required')
            .trim(),
    });


    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    const resetButton = () => {
        // Reset to defaultValues
        reset({
            roleName: "",
            description: "",
        });
    };

    useEffect(() => {
        if (data) {
            reset({
                roleName: data.role_displayname,
                description: data.role_description,
            });
        }
    }, [])

    const navigate = useNavigate()

    const onSubmit = async (value) => {
        try {

            if (mode == "add") {
                const roleName = value.roleName;
                const formattedRole = roleName.toLowerCase().replace(/\s+/g, '');

                const payload = {
                    role_name: formattedRole,
                    role_displayname: value.roleName,
                    role_description: value.description
                }

                const response = await addRoleApi(payload)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    ToastrService.error(response.error.data.message);
                }
            } else {
                console.log(value.id, 'id')
                const payload = {
                    id: data.id,
                    role_displayname: value.roleName,
                    role_description: value.description
                }

                const response = await updateRoleApi(payload)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                    navigate("/roles")
                } else {
                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }



    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <>

                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">
                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Create New Role" : "Manage Role"}
                                </h3>
                                <small className="text-muted">Fill in the details below to create a New Role.</small>

                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Role Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="roleName"
                                        name='roleName'
                                        placeholder='Enter the Role name'
                                        {...register('roleName')}
                                        className="form-control"

                                    />
                                    {errors.roleName && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.roleName.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Description <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        placeholder="Brief description of the role..."
                                        name='description'
                                        {...register('description')}
                                        className="description-input"
                                    />
                                    {errors.description && (
                                        <p className="mt-1" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.description.message}
                                        </p>
                                    )}

                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Create Profile" : "Update Profile"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>
                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default AddRoles;